// extracted by mini-css-extract-plugin
module.exports = {"regions":"PC-module__regions___3TRkd","region":"PC-module__region___1BPgn","prefectures":"PC-module__prefectures___3Gv1v"};